var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceAppleWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1140_1581",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1140_1581)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 5.6C20.5 5.03995 20.5 4.75992 20.391 4.54601C20.2951 4.35785 20.1422 4.20487 19.954 4.10899C19.7401 4 19.4601 4 18.9 4H14.1C13.5399 4 13.2599 4 13.046 4.10899C12.8578 4.20487 12.7049 4.35785 12.609 4.54601C12.5 4.75992 12.5 5.03995 12.5 5.6V6.19438C12.4625 6.97777 12.2099 7.32317 11.8053 7.87643C11.7482 7.95454 11.688 8.03679 11.625 8.125C11.2327 8.67426 10.9881 8.97725 10.7676 9.25039C10.6808 9.3579 10.5978 9.46079 10.5109 9.57225C10.4806 9.60914 10.4515 9.647 10.4235 9.68579L10.375 9.75L10.3828 9.74412C10.1411 10.1028 10 10.5349 10 11V21C10 21.4651 10.1411 21.8972 10.3828 22.2559L10.375 22.25C10.3914 22.2719 10.4075 22.2932 10.4235 22.3142C10.4515 22.353 10.4806 22.3909 10.5109 22.4278C10.5978 22.5392 10.6808 22.6421 10.7676 22.7496L10.7676 22.7496C10.9881 23.0228 11.2327 23.3257 11.625 23.875C11.6879 23.9631 11.748 24.0453 11.8051 24.1233L11.8053 24.1236C12.2099 24.6768 12.4625 25.0222 12.5 25.8056V26.4C12.5 26.9601 12.5 27.2401 12.609 27.454C12.7049 27.6422 12.8578 27.7951 13.046 27.891C13.2599 28 13.5399 28 14.1 28H18.9C19.4601 28 19.7401 28 19.954 27.891C20.1422 27.7951 20.2951 27.6422 20.391 27.454C20.5 27.2401 20.5 26.9601 20.5 26.4V25.8056C20.5375 25.0222 20.7901 24.6768 21.1947 24.1236C21.2518 24.0455 21.312 23.9632 21.375 23.875C21.7673 23.3257 22.0119 23.0228 22.2324 22.7496L22.2324 22.7496C22.3192 22.6421 22.4022 22.5392 22.4891 22.4278C22.5194 22.3909 22.5485 22.353 22.5765 22.3142C22.5925 22.2932 22.6086 22.2719 22.625 22.25L22.6172 22.2559C22.8589 21.8972 23 21.4651 23 21V15.25C23.4142 15.25 23.75 14.9142 23.75 14.5V13C23.75 12.5858 23.4142 12.25 23 12.25V11C23 10.5349 22.8589 10.1028 22.6172 9.74412L22.625 9.75L22.5765 9.6858C22.5485 9.647 22.5194 9.60913 22.4891 9.57224C22.4022 9.46081 22.3192 9.35795 22.2324 9.25047L22.2324 9.2504C22.0119 8.97725 21.7673 8.67427 21.375 8.125C21.312 8.03679 21.2518 7.95454 21.1947 7.87643C20.7901 7.32317 20.5375 6.97777 20.5 6.19438V5.6ZM12.25 9.75H20.75C21.4404 9.75 22 10.3096 22 11V21C22 21.6904 21.4404 22.25 20.75 22.25H12.25C11.5596 22.25 11 21.6904 11 21V11C11 10.3096 11.5596 9.75 12.25 9.75Z",
    fill: "#006EBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAppleWatch);
export default __webpack_public_path__ + "static/media/device-apple-watch.77b7ef6159c0026eeea49ac352acab6f.svg";
export { ForwardRef as ReactComponent };